export default __webpack_public_path__ + "static/media/qq-square.a0c27ce6.svg";